import { PickupInfo } from "../../../../reducers/shoppingCartOrder";
import { PickUpInfo } from "./ShipmentsStyles";
import { formatReadablePhoneNumber } from "../../../../utils/valueFormatting";

export default function OrderPickUpContact({
  pickupInfo,
}: {
  pickupInfo: PickupInfo;
}) {
  return (
    <PickUpInfo>
      <div>Pickup contact:</div>
      <div>{pickupInfo.name}</div>
      {pickupInfo.company_name && <div>{pickupInfo.company_name}</div>}
      <div>{formatReadablePhoneNumber(pickupInfo.phone_number)}</div>
    </PickUpInfo>
  );
}
